import React from 'react';
import { getFieldSetting } from '../helpers/HelperFunctions.js';

const SwitcherInput = (props) => {
    const { name, value, label, settings, disabled } = props;

    const checked = value?.toString().toLowerCase() === 'true';
    // WarningText із Settings показується, коли перемикач вимкнено
    const warningText = getFieldSetting(settings, 'WarningText');
    const showWarning = !!warningText && !checked;

    return (<div className={"switcher-form-container" + (showWarning ? " warning" : "")}>
        <label className={"switcher-form" + (disabled ? " disabled" : "")} htmlFor={name}>
            <span className="switcher-label">{label}</span>
            <input id={name} name={name} checked={checked} onChange={props.onChange} type="checkbox" disabled={disabled ? "disabled" : ""} />
            <span className="switcher" />
        </label>
        {showWarning && <div className="switcher-warning">{warningText}</div>}
    </div>);
}

export default SwitcherInput;
